import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAvailabilityModal from './confirm-availability-modal';
import AvailabilityMiniModal from './availability-mini-modal';
import CalendarAvailabilityApi from '../../../../api/api-calendar-availability';
import { StatsigContext } from '../../elements-statsig-provider/statsig-context';
import { canShowConfirmAvailModal } from './util/availability-cookie-util';

const AvailabilityModalsContainer = ({
  profileSSOid,
  accessToken
}, context) => {
  const [showLargeModal, setShowLargeModal] = useState(false);
  const [showMiniModal, setShowMiniModal] = useState(false);
  const [dateBlocks, setDateBlocks] = useState([]);

  const {
    initialized,
    featureGates
  } = useContext(StatsigContext);

  const getConfirmingAvailabilityParam = () => {
    const { location } = context.router;
    const params = new URLSearchParams(location.search);
    return 'true' === params.get('confirming_availability');
  };

  const checkAvailability = async () => {
    const isFeatureEnabled = featureGates.host_confirm_availability_modal ?? false;
    if (!isFeatureEnabled) return;

    const {
      confirmation_needed: confirmationNeeded,
      dates: dateBlocks
    } = await CalendarAvailabilityApi.checkIfCalendarNeedsUpdate(
      profileSSOid,
      accessToken
    );

    if (confirmationNeeded) {
      setDateBlocks(dateBlocks);

      const canShowLargeModal = canShowConfirmAvailModal(getConfirmingAvailabilityParam(), profileSSOid);
      setShowLargeModal(canShowLargeModal);
      setShowMiniModal(!canShowLargeModal);
    }
  };

  const confirmAvailability = async () => {
    return CalendarAvailabilityApi.confirmCalendarAvailability(profileSSOid, accessToken);
  };

  const handleLargeModalConfirm = () => {
    confirmAvailability();
    setShowLargeModal(false);
  };

  const handleLargeModalDismiss = () => {
    setShowMiniModal(true);
    setShowLargeModal(false);
  };

  const handleMiniModalDismiss = () => {
    setShowMiniModal(false);
  };

  useEffect(() => {
    if (initialized) {
      checkAvailability();
    }
  }, [initialized]);

  return (
    <>
      {showLargeModal && (
        <ConfirmAvailabilityModal
          dates={dateBlocks}
          profileSSOid={profileSSOid}
          onDismiss={handleLargeModalDismiss}
          onConfirm={handleLargeModalConfirm}
        />
      )}
      <AvailabilityMiniModal
        isModalVisible={showMiniModal}
        profileSSOid={profileSSOid}
        onDismiss={handleMiniModalDismiss}
        onConfirm={confirmAvailability}
      />
    </>
  );
};

AvailabilityModalsContainer.propTypes = {
  accessToken: PropTypes.string.isRequired,
  profileSSOid: PropTypes.string.isRequired
};

AvailabilityModalsContainer.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = (state) => ({
  profileSSOid: state.profile.SSOid,
  accessToken: state.auth.accessToken
});

export default connect(mapStateToProps)(AvailabilityModalsContainer);
